<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('zip-to-tar-bz2-converter', 'ZIP to TAR.BZ2');

function handleBatchCreated(batchId: string) {
  console.log('[ZIP to TAR.BZ2 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[ZIP to TAR.BZ2 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[ZIP to TAR.BZ2 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[ZIP to TAR.BZ2 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[ZIP to TAR.BZ2 Converter] Credits updated:', credits);
}
</script>
